
export class ProfileRepository implements IProfileRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getProfiles(): Promise<Profile[]> {
        const response = await this.httpService.get<Data<Profile[]>>('/v1/profile');
        return response.data;
    }

    async getProfile(profile_id: number): Promise<Profile> {
        const response = await this.httpService.get<Data<Profile>>(`/v1/profile/${profile_id}`);
        return response.data;
    }

    async createProfile(data: ProfileCreateSchema): Promise<Profile> {
        const response = await this.httpService.post<Data<Profile>, ProfileCreateSchema>('/v1/profile', { data });
        return response.data;
    }

    async updateProfile(data: ProfileSchema | ProfileSchema[]): Promise<Profile> {
        const response = await this.httpService.patch<Data<Profile>, ProfileSchema | ProfileSchema[]>('/v1/profile', { data });
        return response.data;
    }

    async assignPermission(data: ProfilePermissionSchema): Promise<ProfilePermission[]> {
        const response = await this.httpService.post<ProfilePermission[], ProfilePermissionSchema>('/v1/profile/permission', { data });
        return response;
    }

    async assignView(data: ProfileViewSchema): Promise<ProfileView[]> {
        const response = await this.httpService.post<ProfileView[], ProfileViewSchema>('/v1/profile/view', { data });
        return response;
    }

    async assignTag(data: ProfileTagSchema): Promise<ProfileTag[]> {
        const response = await this.httpService.post<ProfileTag[], ProfileTagSchema>('/v1/profile/tag', { data });
        return response;
    }

}